import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import { getUpdateLog } from 'Global/Stores/debug'

import * as selectors from './selectors'

const Enhancer = WrappedComponent => {
  class DebugModuleEnhancer extends Component {
    static propTypes = {
      getUpdateLog: PropTypes.func.isRequired,
      updateLogDone: PropTypes.bool.isRequired,
      updateLogError: PropTypes.bool.isRequired,
      updateLogEvents: PropTypes.array.isRequired,
      updateLogNewestEvent: PropTypes.object,
      updateLogPending: PropTypes.bool.isRequired,
    }

    componentDidMount() {
      const { getUpdateLog, updateLogDone } = this.props

      if (!updateLogDone) {
        getUpdateLog()
      }
    }

    render() {
      const { updateLogError, updateLogEvents, updateLogPending } = this.props

      return (
        <WrappedComponent
          hasError={updateLogError}
          loaderPending={updateLogPending && !updateLogError}
          updateLogEvents={updateLogEvents}
          {...this.props}
        />
      )
    }
  }

  const mapStateToProps = (state, ownProps) => ({
    updateLogDone: selectors.updateLogDone(state),
    updateLogError: selectors.updateLogError(state),
    updateLogEvents: selectors.updateLogEvents(state),
    updateLogNewestEvent: selectors.updateLogNewestEvent(state),
    updateLogPending: selectors.updateLogPending(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    getUpdateLog: () => dispatch(getUpdateLog()),
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(DebugModuleEnhancer)
}

export default Enhancer
